import { ss } from '@/utils/storage'

const LOCAL_NAME = 'chatStorage'

export function defaultState(): Chat.ChatState {
  const sessionId = String(new Date().getTime())
  return {
    active: sessionId,
    usingContext: true,
    history: [{ sessionId, title: 'New Chat', isEdit: false }],
    chat: [{ sessionId, data: [] }],
    sceneList: [],
    currentScene: null,
    currentSessionId: '',
    recommendList: [],
  }
}

export function getLocalState(): Chat.ChatState {
  const localState = ss.get(LOCAL_NAME)
  return { ...defaultState(), ...localState }
}

export function setLocalState(state: Chat.ChatState) {
  ss.set(LOCAL_NAME, state)
}
